import {
  IPermission,
  IPermissionCreate,
  IPermissionTable,
  IPagedData,
  IPagedSearch,
  TableStatus,
} from '@evencel/models';
import { Selectable } from '@evencel/ui';

export class GetPermission {
  public static readonly type = '[Permission] GetPermission';
  constructor(public id: string) {}
}

export class ActivatePermission {
  public static readonly type = '[Permission] ActivatePermission';
  constructor(public permission: IPermissionTable) {}
}

export class SearchPermissions {
  public static readonly type = '[Permission] SearchPermissions';
  constructor(public data: IPagedSearch) {}
}

export class CreatePermission {
  public static readonly type = '[Permission] SavePermission';
  constructor(public permission: IPermissionCreate) {}
}

export class UpdatePermission {
  public static readonly type = '[Permission] UpdatePermission';
  constructor(public permission: IPermission) {}
}

export class DeletePermission {
  public static readonly type = '[Permission] DeletePermission';
  constructor(public permission: IPermissionTable) {}
}

export class RestorePermission {
  public static readonly type = '[Permission] RestorePermission';
  constructor(public permission: IPermissionTable) {}
}

export class PermissionSelected extends Selectable<IPermission> {
  public static readonly type = '[Permission] PermissionSelected';
  constructor(
    public override item: IPermission,
    public override durty = false
  ) {
    super(item);
  }
}

export class PermissionDeselect extends Selectable<IPermission> {
  public static readonly type = '[Permission] PermissionDeselect';
  constructor(public override item: IPermission) {
    super(item);
  }
}

export class GetPermissionsResponse {
  public static readonly type = '[Permission] GetPermissionsResponse';
  constructor(
    public pagedData: IPagedData<IPermission>,
    public status: TableStatus
  ) {}
}

export class GetPermissionResponse {
  public static readonly type = '[Permission] GetPermissionResponse';
  constructor(public permission: IPermission) {}
}
